export default {"src":"/_next/static/media/box_24.cc9ceef0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};